import React, { useState, useRef, useEffect } from 'react';
import { Styles } from '../../../config/design/styles';
import { getDataTableLocalization } from "../../../config/Translate";
import axios from "axios";
import { defaultVariables } from "../../../config/index";
import { connect } from "trim-redux";
import MaterialTable from "material-table";
import { tableIcons } from "../../../config/design/TableIcons";
import AddFile from "./Components/AddFile";
import { TableCount, TablePage } from "../../../config/Permissions";
import { showTableDate, translateKey, truncate } from "../../../config/values";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Avatar from '@mui/material/Avatar';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import {
    DescriptionRounded,
    ExpandMoreRounded,
    FilterListRounded,
    GetApp,
    GifRounded,
    OndemandVideoRounded,
    OpenInNew,
    PlayCircleFilledOutlined
} from "@mui/icons-material";
import Button from "@mui/material/Button";
import SubTitle from "../../components/elements/SubTitle";
import Role from "../../components/elements/Role";
import { withStyles } from "@mui/styles";
import LinkIcon from "@mui/icons-material/Link";
import {useIsSmall} from "../../../config/hooks/useWindowDimensions";

const FileManager = (props) => {
    const { classes, fileType: propFileType, user, width, page, selection, handleSetImage, handleSetPreview, onlyFile, defined_width, defined_height, single, modal } = props;
    const isSmall = useIsSmall();

    const tableRef = useRef();
    const [state, setState] = useState({
        owner: 'self',
        type: propFileType !== undefined ? propFileType : 'image',
        fileType: propFileType !== undefined ? propFileType : 'image',
        columns: [
            {
                field: 'source',
                editable: 'never',
                title: translateKey('image'),
                render: rowData => (
                    rowData.type === 'image' ?
                        rowData.extension === 'gif' ?
                            <GifRounded style={{ fontSize: 40, color: "#6d6d6d" }} /> :
                            <img className={classes.FMThumbnail} alt="avatar" src={rowData.thumbnail} /> :
                        rowData.type === 'video' ?
                            !!rowData.preview ?
                                <div className={classes.thumbnailWithPreview}>
                                    <img className={classes.FMThumbnail} alt="avatar" src={rowData.preview} />
                                    <PlayCircleFilledOutlined style={{ fontSize: 30, color: "#6d6d6d", opacity: 0.7 }} />
                                </div>
                                :
                                <OndemandVideoRounded style={{ fontSize: 40, color: "#6d6d6d" }} /> :
                            <DescriptionRounded style={{ fontSize: 40, color: "#6d6d6d" }} />
                )
            },
            {
                title: translateKey('imageName'),
                field: 'ImageName',
                editable: 'never',
                render: rowData => (
                    rowData.ImageName + "." + rowData.extension
                )
            },
            {
                title: translateKey('alt'),
                hidden: user.role.type !== "admin" || (isSmall),
                field: 'alt',
                render: rowData => (
                    truncate(rowData.alt, 18)
                )
            },
            {
                title: translateKey('ownerMedia'),
                editable: 'never',
                field: 'owner',
                hidden: isSmall
            },
            {
                title: translateKey('uploadedDate'),
                editable: 'never',
                field: 'lastUpdate',
                hidden: isSmall,
                render: rowData =>
                    <Typography className={classes.dateTable}>
                        {showTableDate(rowData.created_at)}
                    </Typography>
            },
            {
                title: translateKey('link'),
                editable: 'never',
                field: 'link',
                hidden: !page,
                render: rowData => (
                    rowData.type === 'image' ?
                        <IconButton color="secondary" onClick={() => OpenDialog(rowData)}>
                            <LinkIcon />
                        </IconButton> :
                        rowData.extension === "youtube" ?
                            <IconButton target="_blank" component="a" href={`${defaultVariables.youtube}${rowData.source_id}`}>
                                <OpenInNew color="primary"/>
                            </IconButton> :
                            <IconButton component="a" href={rowData.source}>
                                <GetApp color="primary" />
                            </IconButton>
                )
            },
            {
                title: translateKey('activity'),
                editable: 'never',
                field: 'action',
                hidden: !selection || !!isSmall,
                render: rowData => (
                    <Button color="secondary" variant="outlined" size="small" startIcon={<GetApp/>}>
                        {translateKey('insert')}
                    </Button>
                )
            },
        ],
        data: [],
        ChangeLoader: false,
        LinkDialog: false,
        links: null,
        open_filter: false,
    });

    const { owner, type, fileType, columns, data, ChangeLoader, LinkDialog, links, open_filter } = state;

    const OpenDialog = (data) => {
        const newLinks = [];
        newLinks[0] = `${defaultVariables.uploads}/FileManager/${data.name}_small.${data.extension}`;
        newLinks[1] = `${defaultVariables.uploads}/FileManager/${data.name}_medium.${data.extension}`;
        newLinks[2] = `${defaultVariables.uploads}/FileManager/${data.name}.${data.extension}`;
        setState(prev => ({ ...prev, links: newLinks, LinkDialog: true }));
    };

    const handleCloseDialog = () => {
        setState(prev => ({ ...prev, LinkDialog: false }));
    };

    const handleClickLink = (link) => {
        navigator.clipboard.writeText(link);
        setState(prev => ({ ...prev, LinkDialog: false }));
    };

    const addImage = (data) => {
        if (handleSetImage !== undefined) {
            handleSetImage(data);
        }
    };

    const upload = (image, preview = null) => {
        if (handleSetImage !== undefined) {
            handleSetImage(image, preview);
        }
        if (preview === null) loadData();
    };

    const handlePreview = (image) => {
        if (handleSetPreview !== undefined) {
            handleSetPreview(image);
        }
    };

    const Changed = () => {
        loadData();
    };

    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };

    const onDeleteFile = async (id, hasNotif = true) => {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/file/remove`, data, config);
            if (response.status === 403) {
                // Handle 403 error
            } else {
                if (response.data.hasError) {
                    // Handle error
                } else {
                    if (hasNotif) {
                        // Show notification
                    }
                }
            }
            loadData();
            return true;
        } catch (error) {
            console.log(error.response);
            return false;
        }
    };

    const onDeleteSelectedFiles = async (data) => {
        await Promise.all(data.map((row) => onDeleteFile(row.id, false)));
        await loadData();
    };

    const onEditFile = (file) => {
        let data = new FormData();
        data.append('id', file.id);
        data.append('alt', file.alt);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        axios.post(`${defaultVariables.url}/file/edit`, data, config)
            .then(response => {
                loadData();
                return true;
            })
            .catch(error => {
                return false;
            });
    };

    const handleChangeLoader = () => {
        setState(prev => ({ ...prev, ChangeLoader: !prev.ChangeLoader }));
    };

    const handleChangeOwner = async (e) => {
        const owner = e.target.value;
        setState(prev => ({ ...prev, owner, ChangeLoader: true }));
        loadData();
    };

    const handleChangeType = async (e) => {
        const type = e.target.value;
        setState(prev => ({ ...prev, type, ChangeLoader: true }));
        loadData();
    };

    const onSelected = (data) => {
        data.forEach(row => addImage(row));
    };

    const loginToken = localStorage.getItem('ACT');
    const formData = new FormData();
    formData.append('type', type);
    formData.append('owner', owner);

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };

    return (
        <Container maxWidth="xl">
            <Grid container spacing={2}>
                <Grid item size={12} className="file-manager-table main-table">
                    <MaterialTable
                        tableRef={tableRef}
                        icons={tableIcons}
                        onRowClick={(evt, selectedRow) => addImage(selectedRow)}
                        localization={getDataTableLocalization()}
                        title={
                            <AddFile
                                ChangeLoader={handleChangeLoader}
                                upload={upload}
                                handlePreview={handlePreview}
                                type={propFileType}
                                single={single}
                                defined_width={defined_width}
                                defined_height={defined_height}
                            />
                        }
                        columns={columns}
                        data={query =>
                            new Promise((resolve, reject) => {
                                axios.post(
                                    `${defaultVariables.url}/file/getAll?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&only_file=${onlyFile ? "yes" : 'no'}&width=${defined_width || ''}&height=${defined_height || ''}`,
                                    formData,
                                    config
                                )
                                    .then(response => {
                                        const data = response.data.data.map(row => ({
                                            thumbnail: `${defaultVariables.uploads}/FileManager/${row.name}_small.${row.extension}`,
                                            source: `${defaultVariables.uploads}/FileManager/${row.name}.${row.extension}`,
                                            ImageName: truncate(row.name, 12),
                                            name: row.name,
                                            extension: row.extension,
                                            alt: row.alt,
                                            type: row.type,
                                            source_id: row.source_id,
                                            owner: `${row.owner.first_name} ${row.owner.last_name}`,
                                            id: row.id,
                                            created_at: row.updated_at
                                        }));

                                        resolve({
                                            data: data,
                                            page: response.data.current_page - 1,
                                            totalCount: response.data.total,
                                        });
                                    })
                                    .catch(error => {
                                        console.log(error.response);
                                    });
                            })
                        }
                        options={{
                            selection: false,
                            pageSize: TablePage,
                            pageSizeOptions: TableCount,
                            sorting: false,
                            search: !isSmall,
                            draggable: false,
                        }}
                        editable={width === "sm" || width === "xs" ? null : {
                            onRowDelete: oldData =>
                                new Promise(resolve => {
                                    setTimeout(() => {
                                        resolve();
                                        onDeleteFile(oldData.id);
                                        setState(prev => {
                                            const newData = [...prev.data];
                                            newData.splice(newData.indexOf(oldData), 1);
                                            return { ...prev, data: newData };
                                        });
                                    }, 600);
                                }),
                        }}
                    />
                </Grid>
            </Grid>
            <Dialog onClose={handleCloseDialog} open={LinkDialog}>
                <DialogTitle>{translateKey('ChooseImageLink')}</DialogTitle>
                {LinkDialog && (
                    <List>
                        <ListItem button onClick={() => handleClickLink(links[0])}>
                            <ListItemText style={{ textAlign: "left" }} primary={links[0]} />
                            <ListItemAvatar style={{ direction: "ltr" }}>
                                <Avatar src={links[0]} className={classes.small}/>
                            </ListItemAvatar>
                        </ListItem>
                        <ListItem button onClick={() => handleClickLink(links[1])}>
                            <ListItemText style={{ textAlign: "left" }} primary={links[1]} />
                            <ListItemAvatar style={{ direction: "ltr" }}>
                                <Avatar src={links[1]}/>
                            </ListItemAvatar>
                        </ListItem>
                        <ListItem button onClick={() => handleClickLink(links[2])}>
                            <ListItemText style={{ textAlign: "left" }} primary={links[2]} />
                            <ListItemAvatar style={{ direction: "ltr" }}>
                                <Avatar src={links[2]} className={classes.large}/>
                            </ListItemAvatar>
                        </ListItem>
                    </List>
                )}
            </Dialog>
        </Container>
    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
    isApp: state.isApp,
});

export default withStyles(Styles)(connect(mstp)(FileManager));